import { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';

const PHONE = '+91 62390 19768';
const WA_NUMBER = '916239019768';

const FloatingWhatsApp = () => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 600);
    return () => clearTimeout(t);
  }, []);

  const sendMessage = (preset) => {
    const text = encodeURIComponent(
      preset ||
        "Hello Arkotherm Furnaces, I'd like to enquire about your industrial furnaces."
    );
    window.open(`https://wa.me/${WA_NUMBER}?text=${text}`, '_blank', 'noopener');
  };

  return (
    <>
      {/* Chat card */}
      {open && (
        <div
          className="fixed bottom-24 right-4 sm:right-6 z-[60] w-[320px] bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden animate-fadeIn"
          data-testid="whatsapp-card"
        >
          <div className="bg-gradient-to-r from-green-600 to-green-500 px-4 py-3 text-white flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                <MessageCircle size={20} />
              </div>
              <div>
                <div className="font-bold text-sm leading-tight">Arkotherm Furnaces</div>
                <div className="text-xs text-white/90">Typically replies in minutes</div>
              </div>
            </div>
            <button
              onClick={() => setOpen(false)}
              className="text-white/80 hover:text-white p-1"
              aria-label="Close"
              data-testid="whatsapp-card-close"
            >
              <X size={18} />
            </button>
          </div>

          <div className="p-4 bg-[#e5ddd5] text-sm">
            <div className="bg-white rounded-lg px-3 py-2 shadow-sm inline-block max-w-[85%]">
              <div className="text-gray-800">
                Hi 👋 How can our heat-treatment team help you today?
              </div>
              <div className="text-[10px] text-gray-400 text-right mt-1">Arkotherm · now</div>
            </div>

            <div className="mt-4 grid gap-2">
              <button
                onClick={() => sendMessage('Hi, I need a quote for a furnace.')}
                className="text-left text-xs bg-white/90 hover:bg-white px-3 py-2 rounded-lg shadow-sm border border-gray-200"
                data-testid="wa-preset-quote"
              >
                💬 Request a quote
              </button>
              <button
                onClick={() => sendMessage('Hi, I need spare parts for my furnace.')}
                className="text-left text-xs bg-white/90 hover:bg-white px-3 py-2 rounded-lg shadow-sm border border-gray-200"
                data-testid="wa-preset-spares"
              >
                🔧 Spare parts enquiry
              </button>
              <button
                onClick={() => sendMessage('Hi, I want to schedule a site visit.')}
                className="text-left text-xs bg-white/90 hover:bg-white px-3 py-2 rounded-lg shadow-sm border border-gray-200"
                data-testid="wa-preset-visit"
              >
                📍 Schedule a site visit
              </button>
            </div>
          </div>

          <button
            onClick={() => sendMessage()}
            className="w-full bg-green-500 hover:bg-green-600 text-white py-3 font-semibold flex items-center justify-center gap-2 transition-colors"
            data-testid="wa-open-chat"
          >
            <MessageCircle size={18} />
            {t('whatsapp_chat')} · {PHONE}
          </button>
        </div>
      )}

      {/* Floating button */}
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label={t('whatsapp_chat')}
        data-testid="whatsapp-floating-btn"
        className={`fixed bottom-5 right-4 sm:right-6 z-[60] flex items-center gap-2 px-4 py-3 rounded-full bg-green-500 hover:bg-green-600 text-white font-bold shadow-2xl transition-all duration-500 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
        style={{ boxShadow: '0 10px 30px -10px rgba(34,197,94,0.55)' }}
      >
        <span className="relative flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
        </span>
        <MessageCircle size={20} />
        <span className="hidden sm:inline">WhatsApp Us</span>
      </button>
    </>
  );
};

export default FloatingWhatsApp;
